import type { OctopusFeatureToggle } from "@octopusdeploy/octopus-server-client";
import { useBooleanFlagValue } from "@openfeature/react-sdk";

export function useOctopusFeatureToggle(toggle: OctopusFeatureToggle, defaultValue: boolean) {
    return useBooleanFlagValue(toggle, defaultValue);
}

export function usePlatformHubOctopusFeatureToggles() {
    const projectTemplates = useBooleanFlagValue("project-templates", false);
    const complianceReports = useBooleanFlagValue("compliance-reports", false);
    const platformHubGitHubConnections = useBooleanFlagValue("platform-hub-github-connections", false);

    return { projectTemplates, complianceReports, platformHubGitHubConnections };
}

export interface PlatformHubOctopusFeatureToggles {
    projectTemplates: boolean;
    complianceReports: boolean;
    platformHubGitHubConnections: boolean;
}
